import { createFileRoute } from '@tanstack/react-router';
import { AdminItemsPage } from '@/features/admin/admin-items-page';

export const Route = createFileRoute('/admin/items/')({
  component: ItemsIndexRoute,
});

function ItemsIndexRoute() {
  return <AdminItemsPage />;
}
